import { ObjectValues } from 'helpers/types';

export const ONE_PAGE_SECTIONS = {
  ABOUT_THE_COMPANY: 'ABOUT_THE_COMPANY',
  ABOUT_THE_PROJECT: 'ABOUT_THE_PROJECT',
  PRODUCTS_SERVICES: 'PRODUCTS_SERVICES',
  MARKET_AND_SALES: 'MARKET_AND_SALES',
  TEAM: 'TEAM',
  FINANCIAL_PROJECTIONS: 'FINANCIAL_PROJECTIONS',
  FINANCING_NEEDS: 'FINANCING_NEEDS',
  IMPLEMENTATION_PLAN: 'IMPLEMENTATION_PLAN',
} as const;

export type IOnePageSections = ObjectValues<typeof ONE_PAGE_SECTIONS>;
